/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEstimateByMonthDto } from './GetEstimateByMonthDto';
import {
    GetEstimateByMonthDtoFromJSON,
    GetEstimateByMonthDtoFromJSONTyped,
    GetEstimateByMonthDtoToJSON,
} from './GetEstimateByMonthDto';
import type { GetPositionDto } from './GetPositionDto';
import {
    GetPositionDtoFromJSON,
    GetPositionDtoFromJSONTyped,
    GetPositionDtoToJSON,
} from './GetPositionDto';
import type { GetProfileCategoryDto } from './GetProfileCategoryDto';
import {
    GetProfileCategoryDtoFromJSON,
    GetProfileCategoryDtoFromJSONTyped,
    GetProfileCategoryDtoToJSON,
} from './GetProfileCategoryDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetEstimateItemDto
 */
export interface GetEstimateItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    id: string;
    /**
     * 
     * @type {GetEstimateByMonthDto}
     * @memberof GetEstimateItemDto
     */
    estimateByMonth: GetEstimateByMonthDto;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    importFileName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesInvoicesSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseInvoicesSum: string;
    /**
     * 
     * @type {GetPositionDto}
     * @memberof GetEstimateItemDto
     */
    position: GetPositionDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    positionType: GetEstimateItemDtoPositionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    rcSalesTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesSurchargePercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesCommissionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesCommissionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesNetTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesPrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    rcPurchase: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchasePrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    purchaseSurchargePercent: string;
    /**
     * 
     * @type {GetProfileCategoryDto}
     * @memberof GetEstimateItemDto
     */
    profileCategory: GetProfileCategoryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemDto
     */
    isUpSell: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    netCustomerAccount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    numberOfMedia: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    additionalDescription: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    ownName: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    technologyDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    regionDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    formatRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    formatPress: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    formatInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    emissionTypeRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    emissionTypeCinema: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    purchaseFormInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    categoryInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    categoryLabcon: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    copySize: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    purchaseMethod: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    medium: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    labconChannel: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    ballDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    salesCommissionSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    actionGroup: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceExternalWorkPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceCreationPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceChangeProductionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceStrategyPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceProductionBroadcastPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemDto
     */
    serviceClientServicePercent: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemDto
     */
    clone?: boolean;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    countryDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemDto
     */
    pathPhaseDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemDto
     */
    specialistTeam?: GetTeamDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemDto
     */
    deliveryTeam?: GetTeamDto;
}


/**
 * @export
 */
export const GetEstimateItemDtoPositionTypeEnum = {
    Standard: 'Standard',
    Commission: 'Commission',
    TransferredCommission: 'TransferredCommission',
    TechnicalCost: 'TechnicalCost'
} as const;
export type GetEstimateItemDtoPositionTypeEnum = typeof GetEstimateItemDtoPositionTypeEnum[keyof typeof GetEstimateItemDtoPositionTypeEnum];


/**
 * Check if a given object implements the GetEstimateItemDto interface.
 */
export function instanceOfGetEstimateItemDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "estimateByMonth" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "importFileName" in value;
    isInstance = isInstance && "salesInvoicesSum" in value;
    isInstance = isInstance && "purchaseInvoicesSum" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "positionType" in value;
    isInstance = isInstance && "rcSalesTotal" in value;
    isInstance = isInstance && "salesSurchargePercent" in value;
    isInstance = isInstance && "salesDiscountPercent" in value;
    isInstance = isInstance && "salesNet" in value;
    isInstance = isInstance && "salesCommissionPercent" in value;
    isInstance = isInstance && "salesCommissionAmount" in value;
    isInstance = isInstance && "salesNetTechnicalCost" in value;
    isInstance = isInstance && "salesBeerTax" in value;
    isInstance = isInstance && "salesPrintingCosts" in value;
    isInstance = isInstance && "salesOperatingFee" in value;
    isInstance = isInstance && "salesBlockSurcharge" in value;
    isInstance = isInstance && "salesTransferCosts" in value;
    isInstance = isInstance && "salesNetTotal" in value;
    isInstance = isInstance && "rcPurchase" in value;
    isInstance = isInstance && "purchaseTechnicalCost" in value;
    isInstance = isInstance && "purchaseBeerTax" in value;
    isInstance = isInstance && "purchasePrintingCosts" in value;
    isInstance = isInstance && "purchaseOperatingFee" in value;
    isInstance = isInstance && "purchaseBlockSurcharge" in value;
    isInstance = isInstance && "purchaseTransferCosts" in value;
    isInstance = isInstance && "purchaseDiscountPercent" in value;
    isInstance = isInstance && "purchaseNetTotal" in value;
    isInstance = isInstance && "purchaseNet" in value;
    isInstance = isInstance && "purchaseSurchargePercent" in value;
    isInstance = isInstance && "profileCategory" in value;
    isInstance = isInstance && "isUpSell" in value;
    isInstance = isInstance && "netCustomerAccount" in value;
    isInstance = isInstance && "numberOfMedia" in value;
    isInstance = isInstance && "additionalDescription" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "ownName" in value;
    isInstance = isInstance && "technologyDictionary" in value;
    isInstance = isInstance && "regionDictionary" in value;
    isInstance = isInstance && "formatRadio" in value;
    isInstance = isInstance && "formatPress" in value;
    isInstance = isInstance && "formatInternet" in value;
    isInstance = isInstance && "emissionTypeRadio" in value;
    isInstance = isInstance && "emissionTypeCinema" in value;
    isInstance = isInstance && "purchaseFormInternet" in value;
    isInstance = isInstance && "categoryInternet" in value;
    isInstance = isInstance && "categoryLabcon" in value;
    isInstance = isInstance && "copySize" in value;
    isInstance = isInstance && "purchaseMethod" in value;
    isInstance = isInstance && "medium" in value;
    isInstance = isInstance && "labconChannel" in value;
    isInstance = isInstance && "ballDictionary" in value;
    isInstance = isInstance && "salesCommissionSum" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "actionGroup" in value;
    isInstance = isInstance && "serviceExternalWorkPercent" in value;
    isInstance = isInstance && "serviceCreationPercent" in value;
    isInstance = isInstance && "serviceChangeProductionPercent" in value;
    isInstance = isInstance && "serviceStrategyPercent" in value;
    isInstance = isInstance && "serviceProductionBroadcastPercent" in value;
    isInstance = isInstance && "serviceClientServicePercent" in value;

    return isInstance;
}

export function GetEstimateItemDtoFromJSON(json: any): GetEstimateItemDto {
    return GetEstimateItemDtoFromJSONTyped(json, false);
}

export function GetEstimateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEstimateItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimateByMonth': GetEstimateByMonthDtoFromJSON(json['estimateByMonth']),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'comment': json['comment'],
        'importFileName': json['importFileName'],
        'salesInvoicesSum': json['salesInvoicesSum'],
        'purchaseInvoicesSum': json['purchaseInvoicesSum'],
        'position': GetPositionDtoFromJSON(json['position']),
        'positionType': json['positionType'],
        'rcSalesTotal': json['rcSalesTotal'],
        'salesSurchargePercent': json['salesSurchargePercent'],
        'salesDiscountPercent': json['salesDiscountPercent'],
        'salesNet': json['salesNet'],
        'salesCommissionPercent': json['salesCommissionPercent'],
        'salesCommissionAmount': json['salesCommissionAmount'],
        'salesNetTechnicalCost': json['salesNetTechnicalCost'],
        'salesBeerTax': json['salesBeerTax'],
        'salesPrintingCosts': json['salesPrintingCosts'],
        'salesOperatingFee': json['salesOperatingFee'],
        'salesBlockSurcharge': json['salesBlockSurcharge'],
        'salesTransferCosts': json['salesTransferCosts'],
        'salesNetTotal': json['salesNetTotal'],
        'rcPurchase': json['rcPurchase'],
        'purchaseTechnicalCost': json['purchaseTechnicalCost'],
        'purchaseBeerTax': json['purchaseBeerTax'],
        'purchasePrintingCosts': json['purchasePrintingCosts'],
        'purchaseOperatingFee': json['purchaseOperatingFee'],
        'purchaseBlockSurcharge': json['purchaseBlockSurcharge'],
        'purchaseTransferCosts': json['purchaseTransferCosts'],
        'purchaseDiscountPercent': json['purchaseDiscountPercent'],
        'purchaseNetTotal': json['purchaseNetTotal'],
        'purchaseNet': json['purchaseNet'],
        'purchaseSurchargePercent': json['purchaseSurchargePercent'],
        'profileCategory': GetProfileCategoryDtoFromJSON(json['profileCategory']),
        'isUpSell': json['isUpSell'],
        'netCustomerAccount': json['netCustomerAccount'],
        'numberOfMedia': json['numberOfMedia'],
        'additionalDescription': json['additionalDescription'],
        'orderNumber': json['orderNumber'],
        'ownName': json['ownName'],
        'technologyDictionary': GetDictionaryDtoFromJSON(json['technologyDictionary']),
        'regionDictionary': GetDictionaryDtoFromJSON(json['regionDictionary']),
        'formatRadio': GetDictionaryDtoFromJSON(json['formatRadio']),
        'formatPress': GetDictionaryDtoFromJSON(json['formatPress']),
        'formatInternet': GetDictionaryDtoFromJSON(json['formatInternet']),
        'emissionTypeRadio': GetDictionaryDtoFromJSON(json['emissionTypeRadio']),
        'emissionTypeCinema': GetDictionaryDtoFromJSON(json['emissionTypeCinema']),
        'purchaseFormInternet': GetDictionaryDtoFromJSON(json['purchaseFormInternet']),
        'categoryInternet': GetDictionaryDtoFromJSON(json['categoryInternet']),
        'categoryLabcon': GetDictionaryDtoFromJSON(json['categoryLabcon']),
        'copySize': GetDictionaryDtoFromJSON(json['copySize']),
        'purchaseMethod': GetDictionaryDtoFromJSON(json['purchaseMethod']),
        'medium': GetDictionaryDtoFromJSON(json['medium']),
        'labconChannel': GetDictionaryDtoFromJSON(json['labconChannel']),
        'ballDictionary': GetDictionaryDtoFromJSON(json['ballDictionary']),
        'salesCommissionSum': json['salesCommissionSum'],
        'service': json['service'],
        'action': json['action'],
        'actionGroup': json['actionGroup'],
        'serviceExternalWorkPercent': json['serviceExternalWorkPercent'],
        'serviceCreationPercent': json['serviceCreationPercent'],
        'serviceChangeProductionPercent': json['serviceChangeProductionPercent'],
        'serviceStrategyPercent': json['serviceStrategyPercent'],
        'serviceProductionBroadcastPercent': json['serviceProductionBroadcastPercent'],
        'serviceClientServicePercent': json['serviceClientServicePercent'],
        'clone': !exists(json, 'clone') ? undefined : json['clone'],
        'countryDictionary': !exists(json, 'countryDictionary') ? undefined : GetDictionaryDtoFromJSON(json['countryDictionary']),
        'pathPhaseDictionary': !exists(json, 'pathPhaseDictionary') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDictionary']),
        'specialistTeam': !exists(json, 'specialistTeam') ? undefined : GetTeamDtoFromJSON(json['specialistTeam']),
        'deliveryTeam': !exists(json, 'deliveryTeam') ? undefined : GetTeamDtoFromJSON(json['deliveryTeam']),
    };
}

export function GetEstimateItemDtoToJSON(value?: GetEstimateItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'estimateByMonth': GetEstimateByMonthDtoToJSON(value.estimateByMonth),
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'comment': value.comment,
        'importFileName': value.importFileName,
        'salesInvoicesSum': value.salesInvoicesSum,
        'purchaseInvoicesSum': value.purchaseInvoicesSum,
        'position': GetPositionDtoToJSON(value.position),
        'positionType': value.positionType,
        'rcSalesTotal': value.rcSalesTotal,
        'salesSurchargePercent': value.salesSurchargePercent,
        'salesDiscountPercent': value.salesDiscountPercent,
        'salesNet': value.salesNet,
        'salesCommissionPercent': value.salesCommissionPercent,
        'salesCommissionAmount': value.salesCommissionAmount,
        'salesNetTechnicalCost': value.salesNetTechnicalCost,
        'salesBeerTax': value.salesBeerTax,
        'salesPrintingCosts': value.salesPrintingCosts,
        'salesOperatingFee': value.salesOperatingFee,
        'salesBlockSurcharge': value.salesBlockSurcharge,
        'salesTransferCosts': value.salesTransferCosts,
        'salesNetTotal': value.salesNetTotal,
        'rcPurchase': value.rcPurchase,
        'purchaseTechnicalCost': value.purchaseTechnicalCost,
        'purchaseBeerTax': value.purchaseBeerTax,
        'purchasePrintingCosts': value.purchasePrintingCosts,
        'purchaseOperatingFee': value.purchaseOperatingFee,
        'purchaseBlockSurcharge': value.purchaseBlockSurcharge,
        'purchaseTransferCosts': value.purchaseTransferCosts,
        'purchaseDiscountPercent': value.purchaseDiscountPercent,
        'purchaseNetTotal': value.purchaseNetTotal,
        'purchaseNet': value.purchaseNet,
        'purchaseSurchargePercent': value.purchaseSurchargePercent,
        'profileCategory': GetProfileCategoryDtoToJSON(value.profileCategory),
        'isUpSell': value.isUpSell,
        'netCustomerAccount': value.netCustomerAccount,
        'numberOfMedia': value.numberOfMedia,
        'additionalDescription': value.additionalDescription,
        'orderNumber': value.orderNumber,
        'ownName': value.ownName,
        'technologyDictionary': GetDictionaryDtoToJSON(value.technologyDictionary),
        'regionDictionary': GetDictionaryDtoToJSON(value.regionDictionary),
        'formatRadio': GetDictionaryDtoToJSON(value.formatRadio),
        'formatPress': GetDictionaryDtoToJSON(value.formatPress),
        'formatInternet': GetDictionaryDtoToJSON(value.formatInternet),
        'emissionTypeRadio': GetDictionaryDtoToJSON(value.emissionTypeRadio),
        'emissionTypeCinema': GetDictionaryDtoToJSON(value.emissionTypeCinema),
        'purchaseFormInternet': GetDictionaryDtoToJSON(value.purchaseFormInternet),
        'categoryInternet': GetDictionaryDtoToJSON(value.categoryInternet),
        'categoryLabcon': GetDictionaryDtoToJSON(value.categoryLabcon),
        'copySize': GetDictionaryDtoToJSON(value.copySize),
        'purchaseMethod': GetDictionaryDtoToJSON(value.purchaseMethod),
        'medium': GetDictionaryDtoToJSON(value.medium),
        'labconChannel': GetDictionaryDtoToJSON(value.labconChannel),
        'ballDictionary': GetDictionaryDtoToJSON(value.ballDictionary),
        'salesCommissionSum': value.salesCommissionSum,
        'service': value.service,
        'action': value.action,
        'actionGroup': value.actionGroup,
        'serviceExternalWorkPercent': value.serviceExternalWorkPercent,
        'serviceCreationPercent': value.serviceCreationPercent,
        'serviceChangeProductionPercent': value.serviceChangeProductionPercent,
        'serviceStrategyPercent': value.serviceStrategyPercent,
        'serviceProductionBroadcastPercent': value.serviceProductionBroadcastPercent,
        'serviceClientServicePercent': value.serviceClientServicePercent,
        'clone': value.clone,
        'countryDictionary': GetDictionaryDtoToJSON(value.countryDictionary),
        'pathPhaseDictionary': GetDictionaryDtoToJSON(value.pathPhaseDictionary),
        'specialistTeam': GetTeamDtoToJSON(value.specialistTeam),
        'deliveryTeam': GetTeamDtoToJSON(value.deliveryTeam),
    };
}

